const breastPath=[
  

    {
        label:"Please give details of any history of breast cancer",
        controlType:"text area",
        options:[],
        required:false
    },

    {
        label:"Please give details of any family history of breast or ovarian cancer",
        controlType:"text area",
        options:[],
        required: false
    },

    {
        label:"Please give details of any previous mammograms or breast ultrasounds",
        controlType:"text area",
        options:[],
        required:false
    },
    
    {
        label:"If the patient has breast pain alone - has there been a trial of analgesia",
        controlType:"radio button",
        options:["Yes", "No"],
        required:false
    },

    {
        label:"If the patient has isolated eczematous changes  - has there been a trial of topical steroids",
        controlType:"radio button",
        options:["Yes", "No"],
        required:false
    },
]

export default breastPath